import { alpha, Box, Paper, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { Group } from 'utils';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { SystemStyleObject, Theme } from '@mui/system';

export type GroupMemberCountChipProps = {
    group: Group;
    glassUi?: boolean;
    sx?: SystemStyleObject<Theme>;
};

const GroupMemberCountChip = ({
    group,
    glassUi = false,
    sx = {},
}: GroupMemberCountChipProps): ReactElement => {
    const getMemberCountText = () => {
        let countText: string[] = [];
        if (!group.member_counts) {
            return '';
        }

        Object.keys(group.member_counts).forEach((key) => {
            if (!group.member_counts) {
                return;
            }

            if (group.member_counts[key].name === 'Coach') {
                countText.push(`Coaches: ${group.member_counts[key].count}`);
            } else {
                countText.push(
                    `${group.member_counts[key].name}s: ${group.member_counts[key].count}`,
                );
            }
        });

        return countText.join(' | ');
    };
    const getUserCount = () => {
        return group.members_with_users;
    };

    return (
        <Paper
            variant="elevation"
            sx={[
                {
                    p: 2,
                    m: 0,
                    textAlign: 'center',
                    borderRadius: 3,
                    minWidth: { xs: '100%', sm: 180 },
                    backgroundColor: '#ffffff',
                },
                glassUi
                    ? {
                          background: (theme) =>
                              `linear-gradient(135deg, ${alpha(
                                  theme.palette.background.paper,
                                  0.72,
                              )} 0%, ${alpha(theme.palette.background.paper, 0.52)} 100%)`,
                          backdropFilter: 'blur(18px) saturate(170%)',
                          WebkitBackdropFilter: 'blur(18px) saturate(170%)',
                          border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.22)}`,
                          boxShadow: (theme) =>
                              `0 10px 28px ${alpha(theme.palette.common.black, 0.14)}`,
                      }
                    : {},
                sx,
            ]}
        >
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {group.members_count
                        ? `Total Members: ${group.members_count}`
                        : `No members are in this group`}
                </Typography>
                <Box display="flex" alignItems="center" sx={{ marginTop: 1 }}>
                    <VerifiedUserIcon sx={{ color: '#1B9CEA', fontSize: 'medium' }} />
                    <Typography
                        variant="caption"
                        style={{ color: getUserCount() === 0 ? '#ff3d60' : '#1B9CEA' }}
                    >
                        {getUserCount() > 0
                            ? `Total Users: ${getUserCount()}`
                            : `No users are in this group`}
                    </Typography>
                </Box>
                {Boolean(group.members_count) && (
                    <Typography variant="caption" color="textSecondary" sx={{ mt: 0.75 }}>
                        {getMemberCountText()}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};

export default GroupMemberCountChip;
